module.exports = __webpack_public_path__ + "static/img/news-bg.eeb60412.png";